import { createSvgIcon } from '@mui/material/utils';

export const ReportingIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <path
      d="M8 13.0002L12 9.00024L16 13.0002L20 8.00024"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 3V18.5C4 19.3284 4.67157 20 5.5 20H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>,
  'Reporting',
);
